module.exports = __webpack_public_path__ + "static/media/derecho-civil.7b41c158.jpg";